import React, { useState, useEffect, useContext } from "react";
import TeacherNav from "../Navbars/TeacherNav"; // Import TeacherNav component
import Header from "../Header";
import Footer from "../Footer"; // Assuming Footer is also needed
import { UserContext } from "../UserContext"; // Import UserContext for user data
import "./GradeProjectPage.css";
import { Bell } from "lucide-react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GradeProjectPage = (props) => {
  const location = useLocation();
  const { courseName, courseId } = location.state || [0, 0];
  const { userInfo, onLogout } = useContext(UserContext); // Get userInfo and onLogout from UserContext
  const [studentsData, setStudentsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  useEffect(() => {}, [courseId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Get userInfo to get teacherId
        const userInfoRes = await fetch(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`,
          { credentials: "include" }
        );
        const userInfo = await userInfoRes.json();

        const teacherIdRes = await fetch(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/teacherFromId/${userInfo?.User_id}`
        );
        const teacherData = await teacherIdRes.json();

        // 2. Get students list
        const studentsRes = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentsByCourse/${courseId}/${teacherData?.teacher_id}`
        );
        const studentsList = studentsRes.data?.courseInfo || [];

        // 3. For each student, fetch extra info
        const fetchExtraInfo = async (student) => {
          try {
            const res = await fetch(
              `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUser/${student.id}`
            );
            const data = await res.json();

            const enhancedStudent = {
              ...student,
              activeLessonIndex: 0,
              activeModuleIndex: 0,
              activeLessonValue: student?.lessonData?.[0]?.obtainedMArks,
              activeModuleValue: student?.moduleData?.[0]?.obtainedMArks,
            };

            if (data && data.user) {
              return {
                ...enhancedStudent,
                parentName: data.user.parentname || "N/A",
                avatar: data.user.avatar || "",
                phone: data.user.phonenumber || "N/A",
                dob: data.user.dateofbirth
                  ? new Date(data.user.dateofbirth).toLocaleDateString()
                  : "N/A",
              };
            }
            return enhancedStudent;
          } catch (err) {
            return {
              ...student,
              activeLessonIndex: 0,
              activeModuleIndex: 0,
              activeLessonValue: student?.lessonData?.[0]?.obtainedMArks,
              activeModuleValue: student?.moduleData?.[0]?.obtainedMArks,
            };
          }
        };

        const studentsWithExtraInfo = await Promise.all(
          studentsList.map(fetchExtraInfo)
        );
        setStudentsData(studentsWithExtraInfo);
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
    };

    fetchData();
  }, [courseId]);

  // Filtered students based on search term
  const filteredStudents = studentsData.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMarksChangeLesson = (studentId, value) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId == studentId) {
        return {
          ...student,
          activeLessonValue: parseInt(value),
        };
      }
      return student;
    });
    console.log(updatedStudentData);
    setStudentsData(updatedStudentData);
  };
  const handleMarksChangeModule = (studentId, value) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId == studentId) {
        return {
          ...student,
          activeModuleValue: parseInt(value),
        };
      }
      return student;
    });
    console.log(updatedStudentData);
    setStudentsData(updatedStudentData);
  };

  const handleSave = async (index, studentId) => {
    // alert(index)
    const student = studentsData.filter(
      (item, i) => studentId == item?.studentId
    );
    console.log("student ", student);

    const moduleMarks = student[0]?.activeModuleValue;
    const lessonMarks = student[0]?.activeLessonValue;

    const ModuleId =
      student[0]?.moduleData?.[student[0]?.activeModuleIndex]?.moduleProjectId;
    const lessonId =
      student[0]?.lessonData?.[student[0]?.activeLessonIndex]?.lessonProjectId;

    const ModuleTotalMarks =
      student[0]?.moduleData?.[student[0]?.activeModuleIndex]?.totalMarks;
    const LessonTotalMarks =
      student[0]?.lessonData?.[student[0]?.activeLessonIndex]?.totalMarks;

    if (moduleMarks > ModuleTotalMarks || lessonMarks > LessonTotalMarks) {
      toast.error("Obtain Marks Can't be grater than the Total Marks");
      return;
    }

    const formData = new FormData();
    formData.append("studentId", studentId);
    formData.append("ModuleId", moduleMarks);
    formData.append("lessonId", lessonMarks);

    try {
      const response = await axios.post(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updateMarks`,
        { studentId, moduleMarks, lessonMarks, ModuleId, lessonId }
      );
      toast.success("Marks Updated Successfully");
    } catch (error) {
      toast.error("Failed to Update Marks");
      console.error(error);
    }
  };
  const handleLessonIndexChange = (index, studentId, value = 0) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId === studentId) {
        return {
          ...student,
          activeLessonIndex: index,
          activeLessonValue: value,
        };
      }
      return student;
    });
    console.log(updatedStudentData);

    setStudentsData(updatedStudentData);
  };
  const handleModuleIndexChange = (index, studentId, value = 0) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId === studentId) {
        return {
          ...student,
          activeModuleIndex: index,
          activeModuleValue: value,
        };
      }
      return student;
    });
    console.log(updatedStudentData);

    setStudentsData(updatedStudentData);
  };
  useEffect(() => {}, [studentsData]);
  function ChangeCompleteStatus(e, student, projectType, projectIndex) {
    const isChecked = e.target.checked;
    console.log("ChangeCompleteStatus", student, projectType, projectIndex, isChecked);
    
    // Update the student data with the new completion status
    const updatedStudentData = studentsData.map((s) => {
      if (s.studentId === student.studentId) {
        if (projectType === 'lesson') {
          const updatedLessonData = [...s.lessonData];
          updatedLessonData[projectIndex] = {
            ...updatedLessonData[projectIndex],
            Complete: isChecked
          };
          return {
            ...s,
            lessonData: updatedLessonData
          };
        } else if (projectType === 'module') {
          const updatedModuleData = [...s.moduleData];
          updatedModuleData[projectIndex] = {
            ...updatedModuleData[projectIndex],
            Complete: isChecked
          };
          return {
            ...s,
            moduleData: updatedModuleData
          };
        }
      }
      return s;
    });
    
    setStudentsData(updatedStudentData);
  }

  const handleImageError = (e) => {
    const studentName = e.target.alt || 'Student';
    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(studentName)}&background=random&color=fff&size=40`;
    e.target.onerror = null;
  };

  return (
    <>
      {/* Teacher Navigation Bar */}
      <TeacherNav
        username={userInfo?.username}
        avatar={userInfo?.avatar}
        onLogout={onLogout}
      />
      {/* Page Content */}
      <div className="grade-project-page">
        <Header title="Grade Project" />

        <div className="grade-project-main">
          {/* Left: Student List */}
          <div
            className={`student-list-panel ${
              selectedStudentId ? "hide-on-mobile" : "show-on-mobile"
            }`}
          >
            <input
              type="text"
              placeholder="Search Student"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              list="studentNames"
              className="student-search-bar"
            />
            <datalist id="studentNames">
              {studentsData.map((student, index) => (
                <option key={index} value={student.name} />
              ))}
            </datalist>
            <div className="student-list">
              {filteredStudents.map((student, index) => (
                <div
                  key={index}
                  className={`student-card${
                    selectedStudentId === student.studentId ? " selected" : ""
                  }`}
                  onClick={() => setSelectedStudentId(student.studentId)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={
                      student.avatar && student.avatar !== ""
                        ? (student.avatar.startsWith('http') 
                            ? student.avatar 
                            : `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${student.avatar}`)
                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(student.name)}&background=random&color=fff&size=40`
                    }
                    alt={student.name}
                    className="student-avatar"
                    onError={handleImageError}
                    style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                  />
                  <div className="student-info">
                    <div className="student-name">
                      <b>Student:</b> {student.name}
                    </div>
                    <div className="parent-name">
                      <b>Parent Name:</b> {student.parentName || "N/A"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="student-details-panel">
            {selectedStudentId ? (
              (() => {
                const student = studentsData.find(
                  (s) => s.studentId === selectedStudentId
                );
                if (!student) return null;
                return (
                  <div className="student-details-card">
                    <div className="student-details-header">
                      <img
                        src={
                          student.avatar ||
                          "https://ui-avatars.com/api/?name=" +
                            encodeURIComponent(student.name)
                        }
                        alt="Student Avatar"
                        className="student-avatar-large"
                      />
                      <div>
                        <div className="student-name">
                          <b>Student:</b> {student.name}
                        </div>
                        <div className="parent-name">
                          <b>Parent Name:</b> {student.parentName || "N/A"}
                        </div>
                      </div>
                      <div>
                        
                        <div className="student-dob">
                          <b>📅</b> {student.dob || "N/A"}
                        </div>
                      </div>
                    </div>

                    <div className="grading-controls">
                      <div className="label--name">Lesson Project</div>
                      <div className="project-inputs">
                        <div className="project-inputs-up-row">
                          <input
                            type="checkbox"
                            checked={
                              student?.lessonData[student?.activeLessonIndex]
                                ?.Complete || false
                            }
                            onChange={(e) =>
                              ChangeCompleteStatus(e, student, 'lesson', student?.activeLessonIndex)
                            }
                            style={{ width: "20px", margin: "0" }}
                          />
                          <label>
                            <select
                              id="lesson"
                              onChange={(e) => {
                                handleLessonIndexChange(
                                  e.target.selectedIndex - 1,
                                  student?.studentId,
                                  student?.lessonData[
                                    student?.activeLessonIndex
                                  ]?.obtainedMArks
                                );
                              }}
                            >
                              <option value="" disabled>
                                Select Lesson Project
                              </option>
                              {student.lessonData.map((project, i) => (
                                <option
                                  key={project?.lessonProjectId}
                                  value={project?.lessonProjectId}
                                >
                                  {project?.lessonProjectName}
                                </option>
                              ))}
                            </select>
                          </label>
                        </div>
                        <div className="project-inputs-down-row">
                          <a
                            href={
                              student?.lessonData[student?.activeLessonIndex]?.projectFile?.includes("s3") 
                                ? student?.lessonData[student?.activeLessonIndex]?.projectFile
                                : (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API) +"/uploads/Student_Module_Project/" + student?.lessonData[student?.activeLessonIndex]?.projectFile || "#"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                          <div>
                            <input
                            style={{width: "50px",border: "1px solid #ccc",borderRadius: "5px"}}
                              type="number"
                              defaultValue={
                                student?.lessonData[student?.activeLessonIndex]
                                  ?.obtainedMArks || 0
                              }
                              onChange={(e) =>
                                handleMarksChangeLesson(
                                  student?.studentId,
                                  e.target.value
                                )
                              }
                              placeholder="Marks"
                              inputMode="numeric"
                              max={
                                student?.lessonData[student?.activeLessonIndex]
                                  ?.totalMarks
                              }
                            />
                            <span>
                              /
                              {
                                student?.lessonData[student?.activeLessonIndex]
                                  ?.totalMarks
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="label--name">Module Project</div>
                      <div className="project-inputs">
                        <div className="project-inputs-up-row">
                          <input
                            type="checkbox"
                            checked={
                              student?.moduleData[student?.activeModuleIndex]
                                ?.Complete || false
                            }
                            onChange={(e) =>
                              ChangeCompleteStatus(e, student, 'module', student?.activeModuleIndex)
                            }
                            style={{ width: "50px", margin: "0" }}
                          />
                          <label>
                            <select
                              id="module"
                              onChange={(e) => {
                                handleModuleIndexChange(
                                  e.target.selectedIndex - 1,
                                  student?.studentId,
                                  student?.moduleData[
                                    student?.activeModuleIndex
                                  ]?.obtainedMArks
                                );
                              }}
                            >
                              <option value="" disabled>
                                Select Module Project
                              </option>
                              {student.moduleData.map((moduleProject, i) => (
                                <option
                                  key={moduleProject?.moduleProjectId}
                                  value={moduleProject?.moduleProjectId}
                                >
                                  {moduleProject?.moduleProjectName}
                                </option>
                              ))}
                            </select>
                          </label>
                        </div>
                        <div className="project-inputs-down-row">
                          <a
                            href={
                              student?.moduleData[student?.activeModuleIndex]?.projectFile?.includes("s3")
                                ? student?.moduleData[student?.activeModuleIndex]?.projectFile
                                : (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API) + "/uploads/Student_Lesson_Project/" + student?.moduleData[student?.activeModuleIndex]?.projectFile || "#"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                          <div>
                            <input
                              type="number"
                              style={{width: "50px",border: "1px solid #ccc",borderRadius: "5px"}}
                              defaultValue={
                                student?.moduleData[student?.activeModuleIndex]
                                  ?.obtainedMArks || 0
                              }
                              onChange={(e) =>
                                handleMarksChangeModule(
                                  student?.studentId,
                                  e.target.value
                                )
                              }
                              placeholder="Marks"
                              max={
                                student?.moduleData[student?.activeModuleIndex]
                                  ?.totalMarks
                              }
                              inputMode="numeric"
                            />
                            <span>
                              /
                              {
                                student?.moduleData[student?.activeModuleIndex]
                                  ?.totalMarks
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                      <button
                        className="grade-save-btn"
                        onClick={() => handleSave(index, student.studentId)}
                      >
                        Save
                      </button>
                      {selectedStudentId && (
                        <button
                          className="back-to-list-btn"
                          onClick={() => setSelectedStudentId(null)}
                        >
                          Back
                        </button>
                      )}
                    </div>
                  </div>
                );
              })()
            ) : (
              <div className="student-details-placeholder">
                Select a student to view details and grade projects.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GradeProjectPage;
